<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 外协商表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="role_name === '超级权限' || role_name === '软件管理'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="handerSave"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="名称" required>
                <el-input v-if="formStatus" placeholder="名称" v-model="formData.name"></el-input>
                <span v-else>{{formData.name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="地址">
                <el-input v-if="formStatus" placeholder="地址" v-model="formData.address"></el-input>
                <span v-else>{{formData.address}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="联系人">
                <el-input v-if="formStatus" placeholder="联系人" v-model="formData.contact"></el-input>
                <span v-else>{{formData.contact}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="电话">
                <el-input v-if="formStatus" placeholder="电话" v-model="formData.phone"></el-input>
                <span v-else>{{formData.phone}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注">
                <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                <span v-else>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="使用系统">
                <el-checkbox  @change="useChange(formData.is_use)" v-if="formStatus" v-model="formData.is_use"></el-checkbox>
                <span v-else>{{formData.is_use === true ? '是' : '否'}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="useShow">
              <el-form-item label="用户名" required>
                <el-input v-if="formStatus" placeholder="用户名" v-model="formData.user_name"></el-input>
                <span v-else>{{formData.user_name}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        name: '',
        address: '',
        contact: '',
        phone: '',
        is_use: '',
        user_name: '',
        remark: '',
        details: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      useShow: false,
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable,
      role_name: sessionStorage.getItem('role_name')
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getOutsourceCompanyForm, { OutsourceId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          if (_json.formData != null) {
            _this.formData = _json.formData
            if (_this.formData.is_use === 'True') {
              _this.formData.is_use = true
              _this.useShow = true
            } else {
              _this.formData.is_use = false
              _this.useShow = false
            }
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.creater_id = _this.operator_id
            _this.formData.create_time = _this.currentDate
            _this.useShow = false
          }
        }
      })
    },
    // 使用改变事件
    useChange: function (value) {
      if (value) {
        this.useShow = true
      } else {
        this.useShow = false
      }
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    addHandler: function () {
      this.formData.id = '0'
      this.loadData()
      this.isShow = true
      this.formStatus = true
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.name === '') {
          _this.$message({
            type: 'error',
            message: '外协商名称不能为空'
          })
          return false
        }

        if (_mainData.is_use && _mainData.user_name === '') {
          _this.$message({
            type: 'error',
            message: '用户名不能为空'
          })
          return false
        }
      }
      return true
    },
    // 新增时主从表同时保存
    handerSave: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveOutsourceForm, _this.formData, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'outsource') {
              _this.$message({
                message: '外协商名称已存在',
                type: 'error'
              })
            } else if (_json.status === 'user') {
              _this.$message({
                message: '用户名已存在',
                type: 'error'
              })
            } else if (_json.status === 'ok') {
              _this.$message({
                message: '保存成功',
                type: 'success'
              })
              _this.formData.id = _json.id
              _this.formStatus = false
              _this.parent.loadData()
            }
          }
        })
      }
    }
  },
  components: {

  }
}
</script>
